import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useContext } from 'react';
import { NotificacionContext } from '../context/notificacion_context';
import { services } from '../services/api';
import { GlobalContext } from "../context/global_context";
import LoaderComponent from '../components/admin/LoaderComponent';
// import Button from '@mui/material/Button';
// import { Box, Modal } from '@mui/material';
// import { FaFileAlt } from "react-icons/fa";
// import IconUI from '../components/iu/icon_ui';
// import pdf from '../assets/pdf/criterios.pdf'

const DashboardDep = () => {

  // const style3 = {
  //   position: 'absolute',
  //   top: '50%',
  //   left: '50%',
  //   transform: 'translate(-50%, -50%)',
  //   width: 1200,
  //   bgcolor: 'background.paper',
  //   border: '2px solid #661d40',

  //   boxShadow: 24,
  //   p: 4,
  //   display: "flex",
  //   flexDirection: "column",
  //   overflow: "hidden",
  //   overflowY: "scroll",
  //   height: "90%",
  //   borderRadius: "40px",
  // };

  const goTo = useNavigate();
  const { showNotification } = useContext(NotificacionContext)
  const [loader, setLoader] = useState({
    loading: true
  });

  const [state, setState] = useState({
    estados: [],
    openDocumento: false
  });

  const isLecturaRole = String(localStorage.getItem("rol") || "").toUpperCase() === "LECTURA";
  const isAdminRole = String(localStorage.getItem("rol") || "").toUpperCase() === "ADMIN";
  const isAreaRole = String(localStorage.getItem("rol") || "").toUpperCase() === "AREA";
  const isAreaJuridica = String(localStorage.getItem("area_type") || "").toUpperCase() === "AREA JURIDICA";
  const isAreaPsicologica = String(localStorage.getItem("area_type") || "").toUpperCase() === "AREA PSICOLOGICA";
  const isAreaFondo = String(localStorage.getItem("area_type") || "").toUpperCase() === "AREA DE FONDO DE AYUDA";
  const isUnidadRegional = String(localStorage.getItem("area_type") || "").toUpperCase() === "UNIDAD REGIONAL";
  const isAcompañammiento = String(localStorage.getItem("area_type") || "").toUpperCase() === "AREA DE ATENCIÓN Y ACOMPAÑAMIENTO A VÍCTIMAS";
  const isAsesorRole = String(localStorage.getItem("rol") || "").toUpperCase() === "ASESOR";
  const isPsicologoRole = String(localStorage.getItem("rol") || "").toUpperCase() === "PSICOLOGO";

  // const handleCloseDocumento = () => {
  //   setState({ ...state, openDocumento: false });
  // }

  const { setFiltro, setFiltro2, setAcuse, setFiltroLeida } = useContext(GlobalContext)

  const dashboardStatus = async () => {
    setLoader({ ...loader, loading: true })
    let response = await services({ method: 'GET', service: `countPetitionsByStatus`, body: null });
    if (response.status === 200) {
      setLoader({ ...loader, loading: false })
      setState({ ...state, estados: response.data })
    } else {
      setLoader({ ...loader, loading: false })
      showNotification('error', 'Ups...', 'Ocurrio algo al cargar su archivo', null, 4);
    }
  }

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      dashboardStatus();
      setAcuse('');
      setFiltro('');
      setFiltro2('');
      setFiltroLeida('');
    }

    return () => {
      isMounted = false
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {loader.loading &&
        <LoaderComponent />
      }
      <div id="home" className='home'>

        <div className="container ">
          <div className="d-block justify-content-center text-center">
            <div className="d-flex justify-content-between pt-3">
              <h2 className="mt-4 text-center text-large text-primary text-bolder">
                Bienvenido al Sistema para el Seguimiento de la Atención a Victimas 
              </h2>

              <div className="d-block justify-content-center text-center">
                <h6 className="ms-2 mt-4 text-end text-large text-primary text-bolder">
                  Usuario: {localStorage.nombre}
                </h6>
                <h6 className="ms-2 mt-4 text-end text-large text-primary text-bolder">
                  Area: {localStorage.dependencia}
                </h6>
              </div>
            </div>

            <div>
              <h3 className="mt-4 text-center text-large text-primary text-bolder">
                N° Expedientes: {state.estados.total_peticiones}
              </h3>
            </div>

            <div className="justify-content-center mt-2 mb-2 row row-cols-1 row-cols-md-4 g-4">

              {(isAdminRole || isLecturaRole ) && (
                <div className='col'>
                  <div className="card card--rounded h-100 cursor-pointer justify-content-center" style={{
                    backgroundColor: '#dc3545'
                  }}  
                  onClick={() => {
                    goTo("/peticionesVictimas?status_group=sin_atender_admin");
                  }}

                  >
                    <div className="card-body justify-content-center">
                      <h4 className="card-title text-bolder text-white mb-2">Sin Atender</h4>
                      <p className="text-medium text-bold text-white mb-1">Cantidad: {state.estados.pendientes + state.estados.sin_revisar} </p>
                    </div>
                  </div>
                </div>
              )}

              {(isAreaRole) && (
                <div className='col'>
                  <div className="card card--rounded h-100 cursor-pointer justify-content-center" style={{
                    backgroundColor: '#dc3545'
                  }}  
                  onClick={() => {
                    goTo("/peticionesVictimas?status_group=pendientes");
                  }}

                  >
                    <div className="card-body justify-content-center">
                      <h4 className="card-title text-bolder text-white mb-2">
                      
                        {isAreaFondo || isAcompañammiento
                          ? 'Sin Revisar'
                          : 'Pendientes de Turno'}
                      </h4>
                      <p className="text-medium text-bold text-white mb-1">Cantidad: {state.estados.pendientes}</p>
                    </div>
                  </div>
                </div>
              )}

              {((isAreaRole || isAsesorRole || isPsicologoRole) && !(isAreaFondo || isAcompañammiento)) && (
                <div className='col'>
                  <div
                    className="card card--rounded h-100 cursor-pointer justify-content-center"
                    style={
                      isAsesorRole || isPsicologoRole
                        ? { backgroundColor: '#dc3545' }
                        : undefined
                    }
                    onClick={() => {
                      goTo("/peticionesVictimas?status_group=sin_revisar");
                    }}
                  >
                    <div className="card-body justify-content-center">
                      <h4
                        className={`card-title text-bolder mb-2 ${
                          isAsesorRole || isPsicologoRole ? 'text-white' : 'text-morado'
                        }`}
                      >
                        {isAsesorRole || isPsicologoRole || isUnidadRegional
                          ? 'Sin Revisar'
                          : isAreaPsicologica
                            ? 'Sin Revisar por el Psicólogo'
                            : 'Sin Revisar por el Asesor Victimal'}
                      </h4>
                      <p
                        className={`text-medium text-bold mb-1 ${
                          isAsesorRole || isPsicologoRole ? 'text-white' : 'text-morado'
                        }`}
                      >
                        Cantidad: {state.estados.sin_revisar}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <div className='col'>
                <div className="card card--rounded h-100 cursor-pointer justify-content-center" 
                onClick={() => {
                  goTo("/peticionesVictimas?status_group=en_tramite");
                }}>
                  <div className="card-body justify-content-center">
                    <h4 className="card-title text-bolder text-morado mb-2"> 
                      {isPsicologoRole || isAreaPsicologica
                          ? 'En Proceso de Atención'
                          : 'En Trámite'}
                    </h4>
                    <p className="text-medium text-bold text-morado mb-1">Cantidad: {state.estados.en_tramite}</p>
                  </div>
                </div>
              </div>

            </div>

            <div className=" justify-content-center mt-2 mb-2 row row-cols-1 row-cols-md-4 g-4">
              <div className='col'>
                <div className="card card--rounded h-100 cursor-pointer" onClick={() => {
                  goTo("/peticionesVictimas?status_group=concluidos");
                }}>
                  <div className="card-body">
                    <h4 className="card-title text-bolder text-morado mb-2"> 
                      {isPsicologoRole || isAreaPsicologica
                          ? 'Dados de Alta (Concluidos)'
                          : 'Concluidos'}
                    </h4>
                    <p className="card-text text-medium  text-bold text-morado mb-1 ">Cantidad:{state.estados.concluidos}</p>

                  </div>
                </div>
              </div>

              {(isAdminRole || isAreaJuridica || isAsesorRole || isLecturaRole ) && (
                <div className='col'>
                  <div className="card card--rounded h-100 cursor-pointer" onClick={() => {
                    goTo("/peticionesVictimas?status_group=archivo");
                  }}>
                    <div className="card-body">
                      <h4 className="card-title text-bolder text-morado mb-2">En Archivo</h4>
                      <p className="card-text text-medium  text-bold text-morado mb-1 ">Cantidad:{state.estados.archivo}</p>

                    </div>
                  </div>
                </div>
              )}
        
            </div>

            {/* <div className="d-flex justify-content-end pt-5">
              <div className="d-block justify-content-center pt-5">

                <div className="cursor-pointer fw-bolder" onClick={() => { setState({ ...state, openDocumento: true }) }}> ¡AYUDA!</div>
                <div className=" d-flex pt-2 cursor-pointer fw-bolder " style={{ textDecoration: 'underline' }} onClick={() => { setState({ ...state, openDocumento: true }) }}>
                  <IconUI size={25} >
                    <FaFileAlt className="pe-2" />
                  </IconUI>
                  "CRITERIOS DE ESTADO DE UNA PETICIÓN"
                </div>
                <Modal
                  open={state.openDocumento}
                  onClose={() => handleCloseDocumento()}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className='contenedorModalUrs' sx={style3}>
                    <p className="text-center">DOCUMENTO</p>
                    <iframe style={{ width: "100%", height: "100%" }} title='DOCUMENTO' id="frameAceptacion" src={pdf} className="preview-iframe" ></iframe>
                    <Button sx={{ mt: 2 }} onClick={() => handleCloseDocumento()} >CERRAR</Button>
                  </Box>
                </Modal>
              </div>
            </div> */}

          </div>
        </div>
      </div>
    </>
  )
}

export default DashboardDep;
